import { ReactNode } from 'react'

import { Grid } from '@chakra-ui/react'

interface TwoColumnGridIProps {
  children: ReactNode
}

export const TwoColumnGrid = ({ children }: TwoColumnGridIProps) => {
  return (
    <Grid gap='6' mb='4' templateColumns='repeat(2, 1fr)'>
      {children}
    </Grid>
  )
}
